module.exports = __webpack_public_path__ + "img/suceed@2x.23a6212e.png";